import { Classes, Dialog } from "@blueprintjs/core";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import { getSiteAddress } from "modules/common/services/communication/http";
import { CredentialsActions } from "modules/session/access-links/CredentialsActions";
import { useState } from "react";
import styles from "./CredentialsDialog.module.scss";

export interface Credentials {
    login: string;
    password: string;
}

interface CredentialsDialogProps {
    who: string;
    /** null - пароль ещё не сгенерирован: окно спрашивает подтверждение */
    credentials: Credentials | null;
    onConfirm: () => Promise<unknown>;
    onCopied: () => void;
    onClose: () => void;
    /** Отправить данные на почту; mailDisabled - почему нельзя */
    onMail: () => Promise<unknown>;
    mailDisabled?: string;
}

/**
 * Новый пароль со страницы «Пользователи»: подтверждение (действующий пароль сразу
 * перестанет работать) и данные для входа, которые можно скопировать
 */
export const CredentialsDialog = ({
    who,
    credentials,
    onConfirm,
    onCopied,
    onClose,
    onMail,
    mailDisabled,
}: CredentialsDialogProps) => {
    const [busy, setBusy] = useState(false);


    return (
        <Dialog
            isOpen={true}
            title={credentials ? "Данные для входа" : "Новый пароль"}
            isCloseButtonShown={true}
            onClose={onClose}
            backdropClassName="standard"
            className={`figma-dialog ${styles.dialog}`}
        >
            <div className={Classes.DIALOG_BODY}>
                {credentials ? (
                    <>
                        <div className={styles.row}>
                            <span className={styles.label}>Адрес</span>
                            <span className={styles.value}>{getSiteAddress()}</span>
                        </div>
                        <div className={styles.row}>
                            <span className={styles.label}>Логин</span>
                            <span className={styles.value}>{credentials.login}</span>
                        </div>
                        <div className={styles.row}>
                            <span className={styles.label}>Пароль</span>
                            <span className={styles.value}>{credentials.password}</span>
                        </div>
                        <div className={styles.note}>
                            Скопируйте, отправьте или распечатайте данные сейчас — пароль больше не покажется.
                        </div>
                        <CredentialsActions
                            credentials={credentials}
                            name={who}
                            onCopied={() => {
                                onCopied();
                                onClose();
                            }}
                            onMail={onMail}
                            mailDisabled={mailDisabled}
                        />
                    </>
                ) : (
                    <div className={styles.text}>
                        У <b>{who}</b> уже есть пароль. Новый заменит его сразу — текущий перестанет работать.
                    </div>
                )}
            </div>
            {/* данные для входа - кнопки иконками в теле окна, футер только у подтверждения */}
            {!credentials && (
                <div className={Classes.DIALOG_FOOTER}>
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <PlanrButton type="graybtn" size="small" onClick={onClose} disabled={busy}>
                            Отмена
                        </PlanrButton>
                        <PlanrButton
                            type="blueish"
                            size="small"
                            icon="general-shuffle"
                            disabled={busy}
                            onClick={async () => {
                                setBusy(true);
                                await onConfirm();
                                setBusy(false);
                            }}
                        >
                            Сгенерировать
                        </PlanrButton>
                    </div>
                </div>
            )}
        </Dialog>
    );
};
